import { StyledDivider, StyledHeader } from './app-header.style';

export const AppHeader = () => {
    return (
        <StyledHeader>
            <StyledDivider>Гастрономический туризм</StyledDivider>
        </StyledHeader>
    )
}